import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import { type BuyerIncentiveName } from './hooks/useBuyerIncentivesList.ts';

const BuyerIncentiveCopy: FC<{
    name: BuyerIncentiveName;
}> = ({ name }) => {
    switch (name) {
        case 'authenticityGuarantee':
            return (
                <FormattedMessage
                    id="BuyerIncentiveCopy.authenticityGuarantee"
                    defaultMessage="Authenticity Guarantee"
                />
            );

        case 'moneyBackGuarantee':
            return (
                <FormattedMessage
                    id="BuyerIncentiveCopy.moneyBackGuarantee"
                    defaultMessage="Money-Back Guarantee"
                />
            );
        case 'cancelationPolicy':
            return (
                <FormattedMessage
                    id="BuyerIncentiveCopy.cancelationPolicy"
                    defaultMessage="24-Hour Cancellation"
                />
            );
        case 'vettedSellers':
            return (
                <FormattedMessage
                    id="BuyerIncentiveCopy.vettedSellers"
                    defaultMessage="Vetted Professional Sellers"
                />
            );
        case 'priceMatch':
            return (
                <FormattedMessage
                    id="BuyerIncentiveCopy.priceMatch"
                    defaultMessage="Price-Match Guarantee"
                />
            );
        case 'globalDelivery':
            return (
                <FormattedMessage
                    id="BuyerIncentiveCopy.globalDelivery"
                    defaultMessage="Trusted Global Delivery"
                />
            );
        default:
            return null;
    }
};

export default BuyerIncentiveCopy;
